import BaseTab from '../ui/BaseTab';
import { useLayoutState } from '@/provider/layouts/layoutContext';
import { LAYOUT_TYPE } from '@/hooks/layouts/defaultState';
import { Box, CircularProgress } from '@mui/material';
import MultiLayout from '@/pages/Layouts/MultiLayout';
import SingleLayout from '@/pages/Layouts/SingleLayout';
import { useEffect } from 'react';
import { useLayoutUtils } from '@/hooks/layouts/useLayoutUtils';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

type TabLayoutsProps = {
    viewMode?: boolean;
};
const TabLayouts = ({ viewMode }: TabLayoutsProps) => {
    const { t } = useTranslation('common');
    const location = useLocation();
    const { needAutoGeneratePreview } = location.state || {};
    const { state, dispatch } = useLayoutState();
    const { id, isNew, fetchDetail, fetchStoreDetail, fetchCategories, autoGeneratePreview } = useLayoutUtils();

    useEffect(() => {
        if (viewMode) return;
        fetchCategories();
    }, [viewMode]);

    useEffect(() => {
        const initialize = async () => {
            if (viewMode) return;
            if (!isNew) {
                if (needAutoGeneratePreview) {
                    await autoGeneratePreview(Number(id));
                    return;
                }
                await fetchDetail();
            }
        };

        initialize();
        return () => {
            window.history.replaceState({}, '');
        };
    }, [isNew, fetchDetail, viewMode, fetchStoreDetail, location]);

    if (state.loadings.layout || state.loadings.category) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 3, alignItems: 'center' }}>
                <CircularProgress size={50} />
            </Box>
        );
    }

    return (
        <BaseTab
            tab={state.currentTab}
            onChange={(prev) => dispatch({ type: 'SET_CURRENT_TAB', payload: prev as LAYOUT_TYPE })}
            labelOptions={[
                { label: t('Single Layouts'), key: 'SINGLE' },
                { label: t('Multiple Layouts'), key: 'MULTI' },
            ]}
        >
            <Box
                hidden={state.currentTab !== LAYOUT_TYPE.SINGLE}
                style={{ display: state.currentTab === LAYOUT_TYPE.SINGLE ? 'block' : 'none' }}
            >
                <SingleLayout viewMode={viewMode} />
            </Box>
            <Box
                hidden={state.currentTab !== LAYOUT_TYPE.MULTI}
                style={{ display: state.currentTab === LAYOUT_TYPE.MULTI ? 'block' : 'none' }}
            >
                <MultiLayout viewMode={viewMode} />
            </Box>
        </BaseTab>
    );
};
export default TabLayouts;
